import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowRight, Mail } from 'lucide-react';

const C = { orange: '#E08B3C', teal: '#1F8FB8', green: '#1E9E47', ink: '#0A0A0A' };
const LOGO = 'https://customer-assets.emergentagent.com/job_audit-ia-1/artifacts/bwe3ss1d_1.png';

/**
 * Página de registro público DESACTIVADA.
 * El alta de clientes y proveedores la realiza EXCLUSIVAMENTE el administrador.
 * Esta pantalla informa al usuario y lo dirige a la sección de contacto de la landing.
 *
 * Se mantiene el archivo/ruta para backward compatibility con enlaces viejos indexados
 * por buscadores o guardados por usuarios.
 */
export default function Register() {
    // Auto-redirect a la sección contacto de la landing tras 4s por si el usuario no interactúa
    useEffect(() => {
        const t = setTimeout(() => {
            window.location.href = '/#contacto';
        }, 4000);
        return () => clearTimeout(t);
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#FAFAFA' }}>
            <div className="max-w-md w-full bg-white border border-gray-200 p-8 shadow-sm">
                <div className="text-center mb-6">
                    <img src={LOGO} alt="AIGIS" className="h-16 w-16 mx-auto object-contain mb-3" />
                    <div className="text-[10px] uppercase tracking-widest font-bold text-gray-500">AIGIS CERTIFICATE</div>
                </div>

                <div className="border-l-4 pl-4 mb-6" style={{ borderColor: C.orange }}>
                    <h1 className="font-display text-xl font-black mb-2 flex items-center gap-2">
                        <ShieldCheck className="w-5 h-5" style={{ color: C.green }} />
                        Registro por invitación
                    </h1>
                    <p className="text-sm text-gray-700 leading-relaxed">
                        Por seguridad y control de calidad, el alta de <strong>clientes</strong> y{' '}
                        <strong>proveedores</strong> la realiza <strong>únicamente el administrador</strong>{' '}
                        de AIGIS Certificate tras validar los datos generales de tu empresa.
                    </p>
                </div>

                <div className="space-y-3 mb-6">
                    <div className="text-sm text-gray-600">
                        <strong>¿Qué sigue?</strong>
                    </div>
                    <ol className="text-sm text-gray-600 space-y-2 list-decimal list-inside">
                        <li>Envíanos tus datos por el formulario de contacto</li>
                        <li>Nuestro equipo valida y crea tu cuenta</li>
                        <li>Recibes tus credenciales por correo</li>
                    </ol>
                </div>

                <a
                    href="/#contacto"
                    className="w-full text-white px-5 py-3 font-bold inline-flex items-center justify-center gap-2 transition-colors"
                    style={{ background: C.orange }}
                    onMouseOver={(e) => (e.currentTarget.style.background = '#c47728')}
                    onMouseOut={(e) => (e.currentTarget.style.background = C.orange)}
                >
                    <Mail className="w-4 h-4" /> Ir al formulario de contacto <ArrowRight className="w-4 h-4" />
                </a>

                <div className="mt-4 pt-4 border-t border-gray-200 text-center text-sm text-gray-600">
                    ¿Ya tienes cuenta?{' '}
                    <Link to="/login" className="text-[#1F8FB8] hover:underline font-medium">
                        Iniciar sesión
                    </Link>
                </div>

                <div className="mt-4 text-[10px] text-center text-gray-400">
                    Serás redirigido automáticamente al contacto en unos segundos...
                </div>
            </div>
        </div>
    );
}
